;<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.8 4.40001H8L6.8 3.20001H3.2C2.54 3.20001 2.006 3.74001 2.006 4.40001L2 11.6C2 12.26 2.54 12.8 3.2 12.8H12.8C13.46 12.8 14 12.26 14 11.6V5.60001C14 4.94001 13.46 4.40001 12.8 4.40001ZM12.8 11.6H3.2V5.60001H12.8V11.6Z"
      fill="currentColor"
    />
    <path
      d="M9.97083 6.74427L7.6006 10.886C7.56744 10.9556 7.49717 11 7.42001 11H6.40585C6.25887 11 6.1621 10.8468 6.22526 10.7141L8.5955 6.57238C8.62865 6.50271 8.69893 6.45832 8.77609 6.45832H9.79024C9.93723 6.45832 10.034 6.61156 9.97083 6.74427Z"
      fill="currentColor"
    />
  </svg>
</template>
